module.exports = __webpack_public_path__ + "media/icons/error-ffb43012.png";